<div class="componentContent" id="resetPwGroup">
    <div class="registerdiv">
        <div id="registerCard">
            <mat-card class="registerMatCard" align="center" >
                {{'keyword_$375' | translate}}
            </mat-card>
        </div>
    </div>
</div>
